/**
 * Copyright Mántum All Rights Reserved.
 */
import request from '@mantum/kanela-request';
import { source as support, validator } from '@mantum/kanela';

import type { DataSource } from '@mantum/kanela';
import type { Menu } from './type';

export default function (
    dataSource: DataSource | Menu
): Promise<Record<string, unknown>> {
    return new Promise((resolve, reject) => {
        if (!validator.isDataSource(dataSource)) {
            resolve({});
            return;
        }

        const source = dataSource as DataSource;
        const response = request.fetch(source.url, {
            method: source.method,
            body: source.parameter,
            headers: source.headers
        });

        response.then((values: Record<string, unknown>) => {
            resolve(
                support.extract<Record<string, unknown>>(
                    values,
                    source.namespace
                )
            );
        });

        response.catch(reject);
    });
}
